import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

const ResetCompanyProfileModal = ({ open, onClose, onConfirm, isLoading = false }) => (
  <Dialog open={open} onClose={isLoading ? undefined : onClose} maxWidth='sm' fullWidth>
    <DialogTitle sx={{ fontWeight: 700 }}>Reset Company Profile?</DialogTitle>
    <DialogContent>
      <DialogContentText sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
        This will permanently delete your Company Profile, including all documents, URLs and generated
        information. You’ll return to the builder and can start again. This cannot be undone.
      </DialogContentText>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
      <Button onClick={onClose} disabled={isLoading} sx={{ textTransform: 'none' }}>
        Cancel
      </Button>
      <Button
        variant='contained'
        color='error'
        onClick={onConfirm}
        disabled={isLoading}
        sx={{ textTransform: 'none', fontWeight: 600 }}
      >
        {isLoading ? 'Resetting…' : 'Reset Company Profile'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ResetCompanyProfileModal;
